import Tab, { TabProps } from '@mui/material/Tab';
import { alpha } from '@mui/system';
import styled from '@mui/system/styled';

type CPTabProps = TabProps & {
  width?: number;
};

export const CPTab = styled(Tab, {
  shouldForwardProp: (prop) => prop !== 'width',
})<CPTabProps>(({ theme, width }) => ({
  padding: 0,
  minWidth: width ? `${width}%` : 'auto',
  margin: '0 !important',
  minHeight: 55,
  borderBottom: `solid 1px ${theme.palette.divider}`,
  '&.Mui-selected': {
    color: theme.palette.primary.main,
    backgroundColor: alpha(theme.palette.primary.main, 0.08),
  },
}));
